import type { Manifest, v4 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getCustomFieldPath } from '../../application';

/**
 * Sync class for Custom Field Position
 */
export class CustomFieldPosition implements v4.CustomFieldPosition {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getCustomFieldPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getCustomFieldPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.FieldPlacement;
}

/**
 * Sync class for Custom Field
 */
export class CustomField implements v4.CustomField {
    @syncRule({
        manifest: {
            path: getCustomFieldPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    template: string;

    @syncRule({
        manifest: {
            path: getCustomFieldPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    label: string;

    @syncRule({
        manifest: {
            path: getCustomFieldPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    position: CustomFieldPosition;
}
